import * as React from "react";
import { forwardRef } from "react";
const SvgHooksOperation = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Livello_2", "data-name": "Livello 2", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 7.93 23.31", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Livello_3", "data-name": "Livello 3" }, /* @__PURE__ */ React.createElement("path", { d: "M3.97,23.31c-2.19,0-3.97-1.78-3.97-3.97,0-1.84,1.26-3.4,2.97-3.84V0h2v17.38h-1c-1.08,0-1.97.88-1.97,1.97s.88,1.97,1.97,1.97,1.97-.88,1.97-1.97h2c0,2.19-1.78,3.97-3.97,3.97Z" })));
const ForwardRef = forwardRef(SvgHooksOperation);
export default ForwardRef;
